(() => {
  const cartRoot = window.Shopify?.routes?.root || '/';

  const requestCart = async (path, body) => {
    const response = await fetch(`${cartRoot}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
    const result = await response.json();
    if (!response.ok || result.status) {
      throw new Error(result.description || 'Die Auswahl konnte nicht aktualisiert werden.');
    }
    return result;
  };

  const setLoading = (button, loading) => {
    button.classList.toggle('is-loading', loading);
    button.disabled = loading;
    if (loading) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  };

  const getErrorMessage = (button) => {
    const section = button.closest('.obp-cart-page__buddy-offer, .obp-cart-page__addons');
    return section?.querySelector('[data-obp-crosssell-error]');
  };

  const track = (eventName) => {
    try {
      if (window.clarity) window.clarity('event', eventName);
    } catch (error) {
      // Tracking must never interrupt the cart action.
    }
  };

  document.addEventListener('click', async (event) => {
    const addonButton = event.target.closest('[data-obp-cart-addon]');
    const buddyButton = event.target.closest('[data-obp-cart-buddy-target]');
    const button = addonButton || buddyButton;
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    event.preventDefault();
    const errorMessage = getErrorMessage(button);
    const label = button.querySelector('span');
    const originalLabel = label?.textContent || '';
    if (errorMessage) errorMessage.hidden = true;
    setLoading(button, true);
    if (label) label.textContent = 'Wird aktualisiert …';

    try {
      if (addonButton) {
        await requestCart('cart/add.js', {
          items: [{ id: Number(addonButton.dataset.variantId), quantity: 1 }]
        });
        track('cart_cross_sell_added');
      } else {
        await requestCart('cart/change.js', {
          id: buddyButton.dataset.lineKey,
          quantity: Number(buddyButton.dataset.targetQuantity)
        });
        track('cart_buddy_family_offer');
      }

      if (label) label.textContent = '✓ Hinzugefügt';
      window.setTimeout(() => window.location.reload(), 220);
    } catch (error) {
      if (label) label.textContent = originalLabel;
      setLoading(button, false);
      if (errorMessage) {
        errorMessage.textContent = error.message || 'Bitte versuchen Sie es erneut.';
        errorMessage.hidden = false;
      }
    }
  });
})();
